import { action, observable } from 'mobx';
import api from './api';
import { notification } from 'antd';

//TODO: separate rooms store logic from component
export default class RoomsStore {
  // @observable selSiteBuildsCount = 0;
  // @observable selSiteLevelsCount = 0;
  // @observable selSiteRoomsCount = 0;
  // @observable listSubtenants: Array<any> = [];
  // @observable listRooms: Array<any> = [];
  // @action.bound async updateRooms(levelId: number) {
  //   try {
  //     this.listRooms = await api.getRoomsByLevelId(levelId);
  //     this.listSubtenants = await api.getSubtenants();
  //   } catch (e) {
  //     console.error(e);
  //     notification.error({
  //       message: e?.name
  //     });
  //   }
  // this.setState({
  //   listRooms,
  //   listSubtenants,
  //   selRoom: {}
  // });
  // }
}
